import { toast } from 'react-toastify';
import OpSenseToastContainer from './opsense_toast_container';

export {
  OpSenseToastContainer,
  toast
};
